// TerraHaven gentle scroll-reveal
// Adds .accio-revealed to .accio-animate elements when they enter the viewport
// Respects prefers-reduced-motion — skips animation setup entirely if motion is off
(function () {
  'use strict';
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) {
    // Show all elements immediately
    document.querySelectorAll('.accio-animate, .accio-animate-fade').forEach(function (el) {
      el.classList.add('accio-revealed');
    });
    return;
  }
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.accio-animate, .accio-animate-fade').forEach(function (el) {
      el.classList.add('accio-revealed');
    });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('accio-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  function observe() {
    document.querySelectorAll('.accio-animate, .accio-animate-fade').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
